// MODAL

import {gsap} from 'gsap';

let formModalButton = $('.form-modal-button');
let formModalButtonCloseMobile = $('.close-modal-mobile');
let formModalButtonCloseDesktop = $('.close-modal-desktop');
let formModalOverlay = $('.form-modal-overlay');
let formModal = $('.form-modal');

// Form Modal Overlay
function formModalOverlayFunction(){
  // Animation timeline
  let formModalOverlayTL = gsap.timeline({paused:true});

  formModalOverlayTL
    .to(formModalOverlay,{duration: 0, autoAlpha: 0, delay: 0})
    .to(formModalOverlay,{duration: 0.5, autoAlpha: 1, delay: 0});
  return formModalOverlayTL

}
// Store a reference to the timeline that was created to control it later
let formModalOverlayController = formModalOverlayFunction();

// Form Modal
function formModalFunction(){
  // Animation timeline
  let formModalTL = gsap.timeline({paused:true});

  formModalTL
    .to(formModal, {duration: 0, autoAlpha: 0, translateX: '100%', delay: 0})
    .to(formModal, {duration: 0.5, autoAlpha: 1, translateX: 0, delay: 0.5});
  return formModalTL

}
// Store a reference to the timeline that was created to control it later
let formModalController = formModalFunction();


$(formModalButton).on('click', function(e){
  e.preventDefault();
  // Reverse navigation open animation
  formModalOverlayController.play();
  formModalController.play();

  // Re-enable scrolling
  $('body').addClass('scroll-disabled'); // Desktop
  $('body').bind('touchmove'); // Mobile

});

$(formModalOverlay).on('click', function(){
  // Reverse navigation open animation
  formModalOverlayController.timeScale(2).reverse();
  formModalController.timeScale(2).reverse();

  // Re-enable scrolling
  $('body').removeClass('scroll-disabled'); // Desktop
  $('body').unbind('touchmove'); // Mobile
});

$(formModalButtonCloseDesktop).on('click', function(){
  // Reverse navigation open animation
  formModalOverlayController.timeScale(2).reverse();
  formModalController.timeScale(2).reverse();

  // Re-enable scrolling
  $('body').removeClass('scroll-disabled'); // Desktop
  $('body').unbind('touchmove'); // Mobile
});

$(formModalButtonCloseMobile).on('click', function(){
  // Reverse navigation open animation
  formModalOverlayController.timeScale(2).reverse();
  formModalController.timeScale(2).reverse();
});
